const rankingItems = [
  { id: 1, rank: 1, title: '顶流恋情疑曝光深夜同回小区', heat: '98.6万', trend: 'up', change: '+12位' },
  { id: 2, rank: 2, title: '综艺录制现场爆发冲突紧急叫停', heat: '87.3万', trend: 'up', change: '+5位' },
  { id: 3, rank: 3, title: '千万网红虚假宣传品牌方发声明', heat: '76.1万', trend: 'down', change: '-2位' },
  { id: 4, rank: 4, title: '电竞战队官宣重大人员变动引猜测', heat: '65.8万', trend: 'up', change: '+8位' },
  { id: 5, rank: 5, title: '小成本电影逆袭暑期档票房夺冠', heat: '54.2万', trend: 'up', change: '+15位' },
];

export default function Ranking() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
            🏆 大瓜热度榜
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            实时热度排名，今日吃瓜必吃大瓜 TOP5
          </p>
        </div>

        <div className="max-w-2xl mx-auto">
          <div className="rounded-2xl bg-background-50 border border-background-200/70 overflow-hidden">
            {rankingItems.map((item, idx) => (
              <a
                key={item.id}
                href="#ranking"
                className={`flex items-center gap-4 px-5 py-4 hover:bg-primary-50/50 transition-colors cursor-pointer ${
                  idx < rankingItems.length - 1 ? 'border-b border-background-200/70' : ''
                }`}
              >
                <span className={`w-8 h-8 rounded-lg flex items-center justify-center text-sm font-heading font-bold flex-shrink-0 ${
                  item.rank === 1 ? 'bg-primary-500 text-background-50' :
                  item.rank === 2 ? 'bg-accent-500 text-background-50' :
                  item.rank === 3 ? 'bg-secondary-500 text-background-50' :
                  'bg-background-200 text-foreground-500'
                }`}>
                  {item.rank}
                </span>

                <div className="flex-1 min-w-0">
                  <h3 className="text-sm font-medium text-foreground-800 truncate">
                    {item.title}
                  </h3>
                  <div className="flex items-center gap-2 mt-0.5">
                    <span className="text-xs text-foreground-400 whitespace-nowrap">{item.heat}</span>
                    <span className={`text-[10px] font-label font-medium whitespace-nowrap ${
                      item.trend === 'up' ? 'text-primary-500' : 'text-secondary-500'
                    }`}>
                      {item.trend === 'up' ? '🔥' : '📉'} {item.change}
                    </span>
                  </div>
                </div>

                <i className={`w-5 h-5 flex items-center justify-center ${
                  item.trend === 'up' ? 'ri-arrow-up-line text-primary-500' : 'ri-arrow-down-line text-secondary-500'
                }`}></i>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}